export const isFaqEnabled = (tenant) =>
  tenant?.tenantmasterconfig?.header?.faq?.show !== false

export const isCustomerInquiryEnabled = (tenant) =>
  tenant?.tenantmasterconfig?.customerquery?.show !== false

export const isCashbackSummaryEnabled = (tenant) =>
  tenant?.tenantmasterconfig?.profile?.show_cashback_summary !== false
